@if (isLoadingKeys()) {
  <div class="sftp-mgmt__spinner">
    <app-spinner></app-spinner>
  </div>
}


<div class="sftp-mgmt__title clearfix">
  <div class="key-list-title">SFTP Keys for: {{this.client.id}}</div>

  <rn-help-info-popup>
    @if (isLoadingUser()) {
      <div class="sftp-mgmt__spinner">
        <app-spinner></app-spinner>
      </div>
    }
    @if (!isLoadingUser()) {
      <div>
        <div>Client: {{client.id}}</div>
        <div>User Name: {{sftpUser.username}}</div>
        <div>Added On: {{sftpUser.created_at | date : 'short'}}</div>
      </div>
    }
  </rn-help-info-popup>

  @if (!showAddKeyComponent && !isLoadingKeys()) {
    <div class="sftp-mgmt__toggle">
      <button (click)="toggleAddKeyComponent()" [disabled]="" class="btn btn-primary add-key-btn"
        id="trigger-new-sftp-btn">
        <span class="btn-label">Add SFTP Key</span>
      </button>
    </div>
  }
</div>

@if (!isLoadingKeys() && !hasKeys()) {
  <div class="sftp-mgmt__message">There are no SSH keys
  for {{client.company_name}}</div>
}

@if (!isLoadingKeys()) {
  <div class="add-key-container">
    @if (showAddKeyComponent) {
      <div>
        <rn-sftp-new-key (onCancelClicked)="toggleAddKeyComponent()"
          (onSaveClicked)="handleOnSaveClicked($event)"
        [client]="client"></rn-sftp-new-key>
      </div>
    }
    @if (hasKeys()) {
      <div class="key-list-container">
        @for (sftpKey of sftpKeys; track sftpKey; let i = $index) {
          <rn-sftp-key-list-element (onDeleteClicked)="promptForDeleteKey(sftpKey.id)"
          [sftpKey]="sftpKey"></rn-sftp-key-list-element>
        }
      </div>
    }
  </div>
}


<message-dialog #confirmationDialog (affirm)="onDeleteConfirmed.emit(keyIdToDelete)" [showCancel]="true"
[showClose]="true"></message-dialog>
